import App from "./App.svelte";
import "./state";
export const app = new App({
    target: document.body,
    props: {},
});
